import React from 'react';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import breakpoints from '@constants/breakpoints';
import { getResizedImageUrl } from '@lib/image';
import { IDesignerTestimonials } from '@components/pages/DesignerProfile/graphql/designer-profile-query.graphql';

import { DateTime } from 'luxon';
import styles from './Testimonials.module.scss';

interface ITestimonialsProps {
  testimonials: IDesignerTestimonials[] | undefined;
}

const Testimonials = ({ testimonials }: ITestimonialsProps) => {
  const theme = useTheme();

  if (!testimonials) return <></>;

  return (
    <div className={ styles.Root } data-test="reviews">
      <h2 className={ theme.styles.Title2 }>Reviews</h2>

      {testimonials.map(({
        clientName, created, quote, imageUrl
      }: IDesignerTestimonials) => {
        return (
          <div className={classNames(
            theme.styles.Body,
            styles.Testimonial,
          )}
          >
            <div className={styles.Image}>
              <picture>
                {['webp', 'jpeg'].map((format) => (
                  <React.Fragment key={format}>
                    <source
                      srcSet={getResponsiveImages(imageUrl, 663, 355, format)}
                      media={`(min-width: ${breakpoints['medium-tablet']}px)`}
                    />
                    <source
                      srcSet={getResponsiveImages(imageUrl, 340, 191, format)}
                      media={`(min-width: ${breakpoints.desktop}px)`}
                    />
                  </React.Fragment>
                ))}
                <img
                  alt="Board"
                  src={getThumborURL(imageUrl, 663, 355, 'jpeg')}
                />
              </picture>
            </div>

            <div className={styles.Text}>
              <p> &ldquo;{quote}&rdquo; </p>
              <div>
                <strong>{clientName}</strong>, {DateTime.fromISO(created).toFormat('MMMM y')}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

function getResponsiveImages(
  image: string|undefined,
  width: number,
  height: number,
  format: string
) {
  if (!image) return '';
  const main = [`${getThumborURL(image, width, 220, format)} ${width}w`];
  main.push(`${getThumborURL(image, width * 2, height * 2, format)} 2x`);

  return main.join(', ');
}

function getThumborURL(
  url: string | undefined,
  width: number,
  height: number,
  format: string
): string {
  if (!url) return '';
  return getResizedImageUrl({
    format,
    quality: 90,
    url,
    width,
    height,
    fit: 'fit-in'
  });
}

export default Testimonials;
